import { Component, OnInit, ViewChild, TemplateRef, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { Gallery, GalleryItem, ImageItem, ThumbnailsPosition, ImageSize } from "ng-gallery"; //from "@ngx-gallery/core";
//import { Lightbox } from "@ngx-gallery/lightbox";
import { Lightbox } from 'ng-gallery/lightbox';
import { detallesDiscrepanciaSolucionadas } from '../entidades/entidades.component';
import { NbDialogRef } from '@nebular/theme';
//import {SharedModule} from '../shared/shared.module';
import { GalleryModule} from  'ng-gallery';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
// import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
 import { CommonModule } from '@angular/common';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
const dataImageCedente = [
  {
    id: 0,
    src: "assets/img/no_disponible.jpg",
    thumb: "assets/img/no_disponible.jpg"
  }
];
const dataImageReceptor = [
  {
    id: 0,
    src: "assets/img/no_disponible.jpg",
    thumb: "assets/img/no_disponible.jpg"
  }
];
@Component({
    selector: 'app-discrepancias-solucionadas',
    templateUrl: './discrepancias-solucionadas.component.html',
    styleUrls: ['./discrepancias-solucionadas.component.css'],
    standalone: true,
    imports: [GalleryModule,SpinnerComponent, FormsModule,CommonModule,NbCardModule,NbIconModule],
})
export class DiscrepanciasSolucionadasComponent implements OnInit {
  showSpinnerFotos = false;
  imageDataReceptor = dataImageReceptor;
  imageDataCedente = dataImageCedente
  showGallery = true;
  idFotoReceptor = 0;
  idFotoCedente = 0;
  showLoad = false;
  indexFotoReceptor = 0;
  indexFotoCedente = 0;
  fotosCapturadas: Array<any> = [];
  itemsReceptor: GalleryItem[];
  itemsCedente: GalleryItem[];
  myConfig = {
    btnContainerClass: '',            // The CSS class(es) to be applied to the button container
    btnClass: 'default',              // The CSS class(es) that will be applied to the buttons e.g. default is needed for FontAwesome icons, while not needed for Material Icons
    btnSubClass: 'material-icons',    // The CSS class(es) that will be applied to span elements inside material buttons (a Elements)
    zoomFactor: 0.1,                  // The amount that the scale will be increased by
    containerBackgroundColor: '#ccc', // The color to use for the background. This can provided in hex, or rgb(a).
    wheelZoom: true,                  // If true, the mouse wheel can be used to zoom in
    allowFullscreen: false,            // If true, the fullscreen button will be shown, allowing the user to enter fullscreen mode
    allowKeyboardNavigation: true,    // If true, the left / right arrow keys can be used for navigation
    btnShow: {                        // Control which icons should be visible                
      zoomIn: false,
      zoomOut: false,
      rotateClockwise: false,
      rotateCounterClockwise: false,
      next: false,
      prev: false,
      reset: false
    },
    btnIcons: {                       // The icon classes that will apply to the buttons. By default, font-awesome is used.
      zoomIn: {
        classes: 'fa fa-plus',        // this property will be used for FontAwesome and other libraries to set the icons via the classes - choose one: classes or text
        text: 'zoom_in'               // this property will be used for Material-Icons and similar libraries to set the icons via the text
      },
      zoomOut: {
        classes: 'fa fa-minus',
        text: 'zoom_out'
      },
      rotateClockwise: {
        classes: 'fa fa-repeat',
        text: 'rotate_right'
      },
      rotateCounterClockwise: {
        classes: 'fa fa-undo',
        text: 'rotate_left'
      },
      next: {
        classes: 'fa fa-arrow-right',
        text: 'arrow_right'
      },
      prev: {
        classes: 'fa fa-arrow-left',
        text: 'arrow_left'
      },
      fullscreen: {
        classes: 'fa fa-arrows-alt',
        text: 'fullscreen'
      },
      reset: {
        classes: 'fa fa-undo',
        text: 'restore'
      }
    }
  };

  constructor(public gallery: Gallery,
    public galleryCedente: Gallery,
    public lightboxReceptor: Lightbox, public lightboxCedente: Lightbox,
    protected dialogRef: NbDialogRef<DiscrepanciasSolucionadasComponent>) { }
  @Input() public data: detallesDiscrepanciaSolucionadas;
  @ViewChild("itemTemplateReceptor", { static: true }) itemTemplateReceptor: TemplateRef<any>;
  @ViewChild("itemTemplateCedente", { static: true }) itemTemplateCedente: TemplateRef<any>;

  ngOnInit(): void {
    this.showSpinnerFotos = true;
    this.mapeoFotosReceptor();
    this.mapeoFotosCedente();
  }
  mapeoFotosReceptor() {
    if (this.data.listaFotosInspecciones.length > 0) {
      this.imageDataReceptor = [];
      this.data.listaFotosInspecciones.forEach(element => {
        this.imageDataReceptor.push({
          id: element.id,
          src: 'data:image/png;base64,' + element.foto,
          thumb: 'data:image/png;base64,' + element.foto
        })
      });
    }
    // Creat gallery items  
    this.itemsReceptor = this.imageDataReceptor.map(item => {
      return {
        type: "imageViewer",
        data: {
          id: item.id,
          src: item.src,
          thumb: item.thumb
        }
      };
    });
    // Get a lightbox gallery ref
    const lightboxRef = this.gallery.ref("lightboxReceptor");

    // Add custom gallery config to the lightbox (optional)
    lightboxRef.setConfig({
      imageSize: ImageSize.Cover,
      thumbPosition: ThumbnailsPosition.Top,
      itemTemplate: this.itemTemplateReceptor,
     // gestures: false
    });

    // Load items into the lightbox gallery ref
    lightboxRef.load(this.itemsReceptor);
    this.showSpinnerFotos = false;
  }
  mapeoFotosCedente() {
    if (this.data.listaFotosAverias.length > 0) {
      this.imageDataCedente = [];
      this.data.listaFotosAverias.forEach(element => {
        this.imageDataCedente.push({
          id: element.id,
          src: 'data:image/png;base64,' + element.foto,
          thumb: 'data:image/png;base64,' + element.foto
        })
      });
    }
    // Creat gallery items  
    this.itemsCedente = this.imageDataCedente.map(item => {
      return {
        type: "imageViewer",
        data: {
          src: item.src,
          thumb: item.thumb
        }
      };
    });
    // Get a lightbox gallery ref
    const lightboxRefCedente = this.galleryCedente.ref("lightboxCedente");

    // Add custom gallery config to the lightbox (optional)
    lightboxRefCedente.setConfig({
      imageSize: ImageSize.Cover,
      thumbPosition: ThumbnailsPosition.Top,
      itemTemplate: this.itemTemplateCedente,
     // gestures: false
    });

    // Load items into the lightbox gallery ref
    lightboxRefCedente.load(this.itemsCedente);

    this.showSpinnerFotos = false;
  }

  
//GALLERYA MANUAL ****************************************************

//  selectedImage = this.imageData[0].src;

    selectedIndex = 0;
    get selectedImageData() {
      return this.imageDataReceptor[this.selectedIndex].src;
    }

    //Cedente
     get selectedImageDataCedente() {
      return this.imageDataCedente[this.selectedIndex].src;
    }

    lightboxOpen = false;
    zoom = 1;
    readonly zoomStep = 0.1;
    readonly zoomMin = 1;
    readonly zoomMax = 3;

    // Arrastre
    isDragging = false;
    startX = 0;
    startY = 0;
    currentX = 0;
    currentY = 0;

    selectImageByIndex(index: number) {
      this.selectedIndex = index;
      this.resetZoomAndPosition();
    }

    selectImage(src: string) {
      const index = this.imageDataReceptor.findIndex(i => i.src === src);
      if (index !== -1) this.selectImageByIndex(index);
    }

    //Cedente  
    selectImageCedente(src: string) {
      const index = this.imageDataCedente.findIndex(i => i.src === src);
      if (index !== -1) this.selectImageByIndex(index);
    }

    openLightbox() {
      this.lightboxOpen = true;
      this.resetZoomAndPosition();
    }

    closeLightbox() {
      this.lightboxOpen = false;
      this.resetZoomAndPosition();
    }

    resetZoomAndPosition() {
      this.zoom = 1;
      this.currentX = 0;
      this.currentY = 0;
    }

    onWheel(event: WheelEvent) {
      event.preventDefault();

      if (event.deltaY < 0) {
        this.zoom = Math.min(this.zoom + this.zoomStep, this.zoomMax);
      } else {
        this.zoom = Math.max(this.zoom - this.zoomStep, this.zoomMin);
      }

      if (this.zoom <= 1) {
        this.currentX = 0;
        this.currentY = 0;
      }
    }

    onMouseDown(event: MouseEvent) {
      if (this.zoom <= 1) return;
      this.isDragging = true;
      this.startX = event.clientX - this.currentX;
      this.startY = event.clientY - this.currentY;
    }

    onMouseMove(event: MouseEvent) {
      if (!this.isDragging) return;
      this.currentX = event.clientX - this.startX;
      this.currentY = event.clientY - this.startY;
      // Limitar movimiento si quieres aquí
    }

    onMouseUp() {
      this.isDragging = false;
    }

    onMouseLeave() {
      this.isDragging = false;
    }

    // Navegación
    prevImage() {
      if (this.selectedIndex > 0) {
        this.selectImageByIndex(this.selectedIndex - 1);
      }
    }

    nextImage() {
      if (this.selectedIndex < this.imageDataReceptor.length -1) {
        this.selectImageByIndex(this.selectedIndex + 1);
      }
    }
    
    //Cedente
    nextImageCedente() {
      if (this.selectedIndex < this.imageDataCedente.length -1) {
        this.selectImageByIndex(this.selectedIndex + 1);
      }
    }
    


  // END GALLERYA MANUAL ****************************************************


  close() {
    this.dialogRef.close();
  }
}



